import { get, IHttpRequestConfig } from "@/browser";
import { extractDataFromResponse } from "@/core/api";

import { bannerType, IBanner } from "./types";

const API = {
  get: "/api/public/banners/default",
};

export const fetchBanner = (options?: IHttpRequestConfig) => {
  return get<IBanner>(API.get, options).then(extractDataFromResponse).then(bannerType);
};
